/*
Important
This file is used only for the vue3 application.
Changes made here will not be reflected in the Vue2 application.
You need to make changes in the vue2 file also
Vue2 file: wwwroot\js\services\CtaButtonActionService.js
Any clarifications contact divya
*/

import { SmartPathService } from './../../../js/services/SmartPath/SmartPathService'; // not done on vue3
import { LeadService } from './../../../js/services/LeadForms/LeadFormService'; //notyet done on vue3
import { ADDITIONAL_CTA_FORMS, SMARTPATH_CTAs } from './../../../js/constants/constants';
import {
  isGenesisThemeAndGeminiTemplate,
  isInfinitiThemeAndGeminiTemplate,
  isVolkswagenThemeAndGeminiTemplate,
} from './../../../js/constants/ThemeConstants';
import { onCommonLinkLogs } from './../Events/TagManagerServices/TaggingEventForPages';
import {
  appendApplicationQueryParamsToUrl,
  onModalLinkClick,
} from './../../../js/services/CommonUtility'; //not yet done on vue3
export class CtaButtonActionService {
  static getCtaButtonAction(
    buttonActionName,
    routeLink,
    vin,
    dealerId,
    tab,
    dgid = '',
    from = '',
    vehicleType = '',
    customCTAOnClick = ''
  ) {
    const routesList = [
      'schedule-service',
      'contact-us-form',
      'contact-us-page',
      'value-trade-page',
      'value-trade-form',
      'schedule-test-drive',
      'custom-cta',
      'check-availability',
      'bonus-offer',
      'schedule-test-drive-form',
      'request-a-quote-vehicle',
      'contact-us-vehicle',
      'pre-qualified-form-model',
      'estimated-payments',
      'schedule-service',
      'service',
      'scheduleservice',
      'getfinance',
      'getfinancing',
      'financing',
      'get-financing-page',
      'get-financing-form',
      'click-to-call',
      'click-to-call-mobile-desktop',
      'value-your-trade-popup',
      'schedule-test-drive-popup',
      'toyota-smartpath',
      'sign-in',
      'vdv',
      ...ADDITIONAL_CTA_FORMS,
      ...SMARTPATH_CTAs,
    ];

    if (!routesList.includes(buttonActionName)) {
      return false;
    }

    let redirectionType = tab && tab === 'new-tab' ? '_blank' : '_self';

    switch (buttonActionName) {
      case 'contact-us-page':
        window.location.href = window.baseUrl + '/contactus';
        break;
      case 'value-trade-page':
      case 'value-trade-form':
        if (buttonActionName?.toLowerCase() === 'value-trade-page') {
          window.location.href = appendApplicationQueryParamsToUrl(
            window.baseUrl + '/shopperwizard/mytradevalue?vin=' + vin
          );
        } else {
          return buttonActionName;
        }
        break;
      case 'get-financing-form':
      case 'get-financing-page':
      case 'getfinancing':
      case 'financing':
      case 'getfinance':
        LeadService.getLeadformRedirectionDataFinancing(
          vin,
          window.isDealerGroup && window.dgid > 0 ? window.dgid : dgid
        ).then((d) => {
          window.open(appendApplicationQueryParamsToUrl(d.url), d.target);
        });
        break;
      case 'schedule-service':
      case 'service':
      case 'scheduleservice':
        LeadService.getLeadformRedirectionDataScheduleService(vin, dgid).then((d) => {
          if (buttonActionName === 'scheduleservice') {
            onCommonLinkLogs({
              url: d.url ? d.url : '/scheduleservice',
              label: 'Schedule Service',
            });
          }
          if (d.target === 'modal') {
            onModalLinkClick('/scheduleservice#modal-scheduleservice', d.target);
          } else window.open(appendApplicationQueryParamsToUrl('/scheduleservice'), d.target);
        });

        break;
      case 'schedule-test-drive':
        if (dgid !== '') {
          window.location.href = appendApplicationQueryParamsToUrl(
            window.baseUrl + '/scheduletestdrive?vin=' + vin + '&dgid=' + dgid
          );
        } else {
          window.location.href = appendApplicationQueryParamsToUrl(
            window.baseUrl + '/scheduletestdrive?vin=' + vin
          );
        }
        break;
      case 'custom-cta': {
        if (customCTAOnClick) {
          try {
            const customCTAOnClickEvent = customCTAOnClick.trim();
            if (typeof customCTAOnClickEvent === 'function') {
              customCTAOnClickEvent();
            } else {
              const customCTAOnClickEventWrap = new Function(customCTAOnClickEvent);
              customCTAOnClickEventWrap();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          let target = tab && tab === 'new-tab' ? '_blank' : '_self';
          if (routeLink?.toLowerCase()?.includes('#vin')) {
            routeLink = routeLink.replace('#vin', vin);
          }
          window.open(routeLink, target);
        }
        break;
      }
      case 'estimated-payments':
      case 'toyota-smartpath':
      case 'sp-estimate-payment':
      case 'sp-value-your-trade':
      case 'sp-confirm-availability':
        SmartPathService.smartPathRedirection(
          from,
          vin,
          vehicleType,
          buttonActionName,
          routeLink,
          redirectionType
        );
        return;
      default:
        return buttonActionName;
    }
  }

  static isAnyThemeAndGeminiTemplate() {
    return (
      isVolkswagenThemeAndGeminiTemplate() ||
      isGenesisThemeAndGeminiTemplate() ||
      isInfinitiThemeAndGeminiTemplate()
    );
  }
  static excludeDefaultFontColorForTransact() {
    return this.isAnyThemeAndGeminiTemplate() ? '' : '#fff';
  }
  static getTransactBtnBgColor() {
    return window.transactFontColor || this.excludeDefaultFontColorForTransact();
  }
}
